// Generated, DO NOT EDIT MANUALLY.
import _styles from "#pplx/frontend/aether/primitives/ShimmerPrimitive/ShimmerPrimitive.module.css";

export const styles = _styles;
